import Qualified from '../assets/icon_qualified.svg'
import Unqualified from '../assets/icon_unqualified.svg'
import Winner from '../assets/icon_winner.svg'
import {getPrizeNameByType} from '../helpers/functions'

export const PrizeAnouncement = (props) => {
    const title = props.isWinner ? 'Ai câștigat'  : (props.remainingPrizes === 0 ? 'Încearcă și mâine' : (props.isQualified ? 'Calificat' : 'Nu ești calificat!'))

    const image = props.isWinner ? Winner : (props.isQualified && props.remainingPrizes > 0 ? Qualified : Unqualified)
    console.log(props.remainingPrizes)
    const remainingPrizes = (<>
        {!props.isWinner && <div className="loader-wrapper">
            <div className="loader">
                <div className="loader-inside" style={{width: `${Math.min(100, props.points)}%`}}/>
            </div>
            <p>
                <p>{Math.min(100, props.points)}%</p>
            </p>
        </div>}
        {props.isQualified ? (props.isWinner ?
                <p>Ai castigat <strong>{props.prizeAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' ' + getPrizeNameByType(props.prizeType)}</strong>. <br/> Poți participa și mâine pentru o nouă șansă.</p>
                :
                    <p><strong>{props.username}</strong> este calificat pentru premiile instant. Au mai rămas {props.remainingPrizes} premii și poți fii unul dintre câștigători.</p>
            )
            :
            <p><strong>{props.username}</strong> nu este calificat pentru premiile instant. Au mai rămas {props.remainingPrizes.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')} premii.
                Grăbește-te, ai putea fi chiar tu unul dintre câștigători!</p>
        }
    </>)

    return (
        <div className='card-anouncement'>
            <div className="card-anouncement-wrapper">
                <div className="card-anouncement-header"><img src={image}  alt={''}/><h1>{title}</h1></div>
                <div className="card-anouncement-body">
                    {props.isWinner || props.remainingPrizes > 0 ?
                        remainingPrizes
                        :
                        <p>Toate premiile au fost acordate. Joacă și mâine, obține minim 10 puncte și ai o șansă nouă de câștig!</p>}
                </div>
                <div className="card-anouncement-footer"><p>Continuă să joci!</p>
                </div>
            </div>
        </div>
    )
}